function orderBy(arr: any, label: string, order: "asc" | "desc", labelOfObj: string = undefined) {
  const items = arr;
  if (!items?.length) return;

  return items?.sort(function (a: any, b: any) {
    //itens iguais são classificados igualmente
    const whatLabelA = labelOfObj ? a[label][labelOfObj] : a[label];
    const whatLabelB = labelOfObj ? b[label][labelOfObj] : b[label];

    //Ordenar os booleanos
    if (label === "isBilled") return orderBooleanItem(order, whatLabelA, whatLabelB);

    //Ordenar datas por timeslap
    if (label === "beginnig_at" || label === "end_date" || label === "birth_date") return orderDate(order, whatLabelA, whatLabelB);


    if (whatLabelA === whatLabelB) return 0;

    //verifica se o item é null ou vazio e se o item job_role é undefined e classifica abaixo de qualquer coisa
    if (whatLabelA === null || whatLabelA === "" || whatLabelA[0] === undefined) return 1;
    if (whatLabelB === null || whatLabelB === "" || whatLabelB[0] === undefined) return -1;

    if (label === "purchase_amount" || label === "purchasePrice") return orderNumber(order, whatLabelA, whatLabelB);

    //ApprovalHours
    if (label === "allocationTime") return orderNumber(order, whatLabelA, whatLabelB);
    if (label === "payment_amount") return orderPaymemt(order, whatLabelA, whatLabelB);
    if (label === "timeWorked" || label === "timeApproved") return orderHours(order, whatLabelA, whatLabelB);
    return orderString(order, whatLabelA, whatLabelB);
  });
}

function orderDate(order: string, a: any, b: any) {
  if (a === null || a === "" || a === undefined) return 1;
  if (b === null || b === "" || b === undefined) return -1;

  /* DD/MM/YYYY to timestamp */
  function parseDateToTimestamp(s) {
    var b = s.split(/\D/);
    var d = new Date(b[2], --b[1], b[0]);
    return d && d.getMonth() === b[1] ? d : new Date(NaN);
  }

  var dateA = parseDateToTimestamp(a).getTime();
  var dateB = parseDateToTimestamp(b).getTime();

  if (dateA === dateB) return 0;

  if (order === "asc") {
    //classifica o mais baixo primeiro
    return dateA < dateB ? -1 : 1;
  }

  //classifica o mais alto primeiro
  return dateA < dateB ? 1 : -1;
}

function orderBooleanItem(order: string, a: any, b: any) {
  if (order === "asc") {
    return a === b ? 0 : a ? -1 : 1;
  }
  return a === b ? 0 : a ? 1 : -1;
}

function orderHours(order: string, a: any, b: any) {
  let timeA = a?.split(":")?.reduce((acc, time) => 60 * acc + +time);
  let timeB = b?.split(":")?.reduce((acc, time) => 60 * acc + +time);

  if (order === "asc") {
    //classifica o mais baixo primeiro

    return timeA < timeB ? -1 : 1;
  }
  //classifica o mais alto primeiro
  return timeA < timeB ? 1 : -1;
}

function orderPaymemt(order: string, a: any, b: any) {
  let paymentA = a?.replace(",", ".");
  let paymentB = b?.replace(",", ".");

  if (order === "asc") {
    //classifica o mais baixo primeiro

    return Number(paymentA) < Number(paymentB) ? -1 : 1;
  }
  //classifica o mais alto primeiro
  return Number(paymentA) < Number(paymentB) ? 1 : -1;
}

function orderNumber(order: string, a: any, b: any) {
  if (order === "asc") {
    //classifica o mais baixo primeiro
    return Number(a) < Number(b) ? -1 : 1;
  }
  //classifica o mais alto primeiro
  return Number(a) < Number(b) ? 1 : -1;
}

function orderString(order: string, a: any, b: any) {
  if (order === "asc") {
    //classifica o mais baixo primeiro
    return String(a)?.toLowerCase() < String(b)?.toLowerCase() ? -1 : 1;
  }
  //classifica o mais alto primeiro
  return String(a)?.toLowerCase() < String(b)?.toLowerCase() ? 1 : -1;
}

export { orderBy };
